import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export default function VoiceIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="m20.467 7.694l.246-.566a4.36 4.36 0 0 1 2.22-2.25l.759-.339a.53.53 0 0 0 0-.963l-.717-.319A4.37 4.37 0 0 1 20.724.931L20.47.32a.506.506 0 0 0-.942 0l-.253.61a4.37 4.37 0 0 1-2.25 2.327l-.718.32a.53.53 0 0 0 0 .962l.76.338a4.36 4.36 0 0 1 2.219 2.251l.246.566c.18.414.753.414.934 0M3.055 11H5.07a7.002 7.002 0 0 0 13.858 0h2.016A9.004 9.004 0 0 1 13 18.945V23h-2v-4.055A9.004 9.004 0 0 1 3.055 11M12 1a5 5 0 0 0-5 5v4a5 5 0 0 0 10 0V7h-2v3a3 3 0 1 1-6 0V6a3 3 0 0 1 4.617-2.528l1.08-1.683A5 5 0 0 0 12 1"
        />
      </svg>
    </SvgIcon>
  );
}
